import ReactMarkdown from "react-markdown"
import { isString } from "lodash"

export default class MarkdownArticle extends Component {
  render() {
    const { src, images = {}, figures = {} } = this.props

    return (
      <ReactMarkdown
        source={src}
        renderers={{
          heading: ({ children, level }) => {
            if (level === 1) {
              return <Heading>{children}</Heading>
            }

            return <Heading2>{children}</Heading2>
          },
          image: ({ src, alt }) => {
            const caption =
              alt.indexOf("caption:") === 0
                ? alt.split("caption:")[1].trim()
                : null

            const img = images[src]

            return (
              <Surface gridColumn="screen" alignItems="center" marginY={20}>
                <img src={img} alt={alt} width={800} />
                {caption && (
                  <Text marginTop={5}>
                    <i>{caption}</i>
                  </Text>
                )}
              </Surface>
            )
          },
          paragraph: ({ children }) => {
            const text = children[0].props.children
            if (isString(text) && text.toLowerCase().indexOf("figure:") === 0) {
              const figure = text.split(":")[1].trim()
              if (figures[figure]) {
                return figures[figure]
              } else {
                return (
                  <Surface background="rgba(0, 0, 0, 0.02)" padding={3}>
                    <Text>Missing figure {figure}</Text>
                  </Surface>
                )
              }
            }

            return <Paragraph>{children}</Paragraph>
          },
        }}
      />
    )
  }
}
